export function safeExec<T = any>(func: () => T, defaultValue?: T) {
  try {
    return func();
  } catch (e) {
    if (__DEV__) {
      console.warn(e);
    }
    return defaultValue;
    // production:
    // no op
  }
}

type waitForOption = {
  retryIn?: number;
  maxRetry?: number;
};

export function waitForFn<T>(
  getterFn: () => T,
  callback: (item: T) => void,
  { retryIn = 10, maxRetry = 5 }: waitForOption = {},
): () => void {
  let timeoutHandle: undefined | ReturnType<typeof setTimeout>;
  let shouldTryAgain = maxRetry;

  const checkFn = () => {
    const element = getterFn();
    if (element && shouldTryAgain) {
      callback(element);
    } else {
      shouldTryAgain--;
      timeoutHandle = setTimeout(checkFn, retryIn);
    }
  };

  timeoutHandle = setTimeout(checkFn, retryIn);
  return () => {
    // @ts-ignore
    clearTimeout(timeoutHandle);
  };
}
